export const USER_ROLE = {
  SENIOR: 'SENIOR',
  ADMIN: 'ADMIN',
  CUSTOMER: 'CUSTOMER'
};
